const DIAMANTE_VERMELHO_LABELS: Record<string, string> = {
  'red diamond': 'Red Diamond',
  'red diamond bag': 'Red Diamond Bag',
  'red diamond box': 'Red Diamond Box',
  'red diamond combo': 'Red Diamond Combo'
};

export function getDiamanteVermelhoLabel(
  value: string | null | undefined
): string | null {
  if (value == null || value.trim() === '') {
    return null;
  }
  return DIAMANTE_VERMELHO_LABELS[value.trim()] ?? null;
}
